export enum WgerPermissions {
    // Exercises
    EDIT_EXERCISE = 'exercises.change_exercise',
    DELETE_EXERCISE = 'exercises.delete_exercise',

    ADD_IMAGE = 'exercises.add_exerciseimage',
    EDIT_IMAGE = 'exercises.change_exerciseimage',
    DELETE_IMAGE = 'exercises.delete_exerciseimage',

    ADD_VIDEO = 'exercises.add_exercisevideo',
    EDIT_VIDEO = 'exercises.change_exercisevideo',
    DELETE_VIDEO = 'exercises.delete_exercisevideo',
}
